import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={48}
        height={48}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={24} cy={24} r={24} fill="#C9CC26" />
        <path
            d="M14 14H34M20.049 30.53C21.932 32.178 22.873 33 24 33C25.127 33 26.069 32.177 27.951 30.53L29.951 28.782C30.959 27.9 31.464 27.46 31.731 26.869C32 26.279 32 25.609 32 24.27V21.702M32 18V14H16V24.27C16 25.61 16 26.279 16.268 26.87C16.443 27.255 16.719 27.577 17.171 28M20.5 25H27.5M20.5 20H27.5"
            stroke="white"
            strokeWidth={1.5}
            strokeLinecap="round"
        />
    </svg>
);

const IconAnimate = React.memo(SVGComponent);
export default IconAnimate;
